import { render, staticRenderFns } from "./BatchCall.vue?vue&type=template&id=2a1876df&scoped=true"
import script from "./BatchCall.vue?vue&type=script&lang=js"
export * from "./BatchCall.vue?vue&type=script&lang=js"
import style0 from "./BatchCall.vue?vue&type=style&index=0&id=2a1876df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1876df",
  null
  
)

export default component.exports